import { CommonModule }          from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi }      from '@angular/common/http';
import { NgModule }              from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule }          from '@angular/router';
import { ModalModule }           from 'ngx-bootstrap/modal';

import {
  LucideAngularModule,
  X, Menu, PanelLeftClose, PanelLeftOpen, LayoutDashboard, Wallet,
  Users, Building2, Briefcase, ShoppingBag, Cloud, ScrollText,
  CalendarDays, CalendarClock, FileText, CreditCard,
  Tag,
  FileBarChart, ArrowLeftRight, DollarSign, CalendarPlus, Clock, Receipt,
  CheckCircle, Star, Monitor,
  Bell, LogOut, BarChart2, ShoppingCart, XCircle, Stethoscope, ShieldAlert,
  Inbox, Mail, BellPlus, MessageCircle, Landmark, KeyRound,
  Activity, BookOpen, Home,
} from 'lucide-angular';

import { MessageService }    from '../core/services/message.service';
import { FooterComponent }   from './admin/footer/footer.component';
import { LayoutComponent }   from './admin/layout/layout.component';
import { SidebarComponent }  from './admin/sidebar/sidebar.component';
import { TopbarComponent }   from './admin/topbar/topbar.component';

@NgModule({ declarations: [
        LayoutComponent,
        TopbarComponent,
        SidebarComponent,
        FooterComponent,
    ],
    exports: [LayoutComponent], imports: [CommonModule,
        BrowserAnimationsModule,
        RouterModule,
        ModalModule,
        LucideAngularModule.pick({
            X, Menu, PanelLeftClose, PanelLeftOpen, LayoutDashboard, Wallet,
            Users, Building2, Briefcase, ShoppingBag, Cloud, ScrollText,
            CalendarDays, CalendarClock, FileText, CreditCard,
            Tag,
            FileBarChart, ArrowLeftRight, DollarSign, CalendarPlus, Clock, Receipt,
            CheckCircle, Star, Monitor,
            Bell, LogOut, BarChart2, ShoppingCart, XCircle, Stethoscope, ShieldAlert,
            Inbox, Mail, BellPlus, MessageCircle, Landmark, KeyRound,
            // O sidebar renderiza antes do modulo lazy do monitoramento, que tem seu proprio pick:
            // sem registrar aqui, o item aparece sem icone.
            Activity, BookOpen, Home,
        })], providers: [MessageService, provideHttpClient(withInterceptorsFromDi())] })
export class LayoutModule {}
